import React, { useState, useEffect } from 'react';
import modalConstants from './modalConstants';
import { getObjectFromLocal, removeItemFromLocal } from '../../utilities/utils';
import actions from '../../actions';
import { ButtonToolbar, DropdownButton, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import MessagePopup from '../../components/MessagePopup/MessagePopup';
import { withRouter } from 'react-router-dom';
import constants from '../../constants';
import PropTypes from 'prop-types';
import CancelRapidManual from '../../components/CancelRapidManual/CancelRapidManual';
import UserSetting from '../../images/UserSetting.svg';
import localforage from 'localforage';

let messagePopup = {};
// const propTypes = {
// 	// userRoles: PropTypes.any,
// 	usermanagement: PropTypes.shape({
// 		loggedInUser: PropTypes.shape({
// 			email: PropTypes.any,
// 		}),
// 		userPermissionList: PropTypes.any,
// 	}),
// 	handleSelect: PropTypes.func,
// 	dispatch: PropTypes.func,
// 	history: PropTypes.shape({
// 		push: PropTypes.func,
// 	}),
// };

function SettingMenuList(props) {
	const [authorizedUser, setAuthorizedUser] = useState(false);
	const [modalType, setModalType] = useState('');
	const [confirmPopup, setConfirmPopup] = useState({});
	const [isAnalyticsProject, setIsAnalyticsProject] = useState(false);

	let tempNew = getObjectFromLocal(`newRapidAnnotation_${props?.match?.params?.docId}`);
	let newAnnotation = tempNew ? tempNew : '';
	let tempUpdated = getObjectFromLocal(`updatedAnnotation_${props?.match?.params?.docId}`);
	let updatedAnnotation = tempUpdated ? tempUpdated : '';
	let tempDeleted = getObjectFromLocal(`deletedAnnotation_${props?.match?.params?.docId}`);
	let deletedAnnotation = tempDeleted ? tempDeleted : '';

	useEffect(() => {
		if (props.redUsermanagement?.userPermissionList?.length > 0) {
			userManagement();
		}
	}, [props.redUsermanagement?.userPermissionList]);

	//Description: It checks user role and corresponding permissions to access menu.
	const userManagement = () => {
		if (
			props.redUsermanagement?.userPermissionList?.[0].access == 'Administrator' ||
			props.redUsermanagement?.userPermissionList?.[0].access == 'Company'
		) {
			setAuthorizedUser(true); //SET USER TYPE AS AUTHORIZED USER
		}
		localforage.getItem('isVAStudy').then(enable =>{
			if(!enable){
				setIsAnalyticsProject(true)
			} else {
				setIsAnalyticsProject(false)
			}
		});
		// let profileUser = getObjectFromLocal('user');

		// if (props.redUsermanagement?.loggedInUser?.email) {
		// 	let { userPermissionList } = props.redUsermanagement;
		// 	if (
		// 		userPermissionList?.[0].access == 'Administrator' ||
		// 		userPermissionList?.[0].access == 'Company'
		// 	) {
		// 		setAuthorizedUser(true); //SET USER TYPE AS AUTHORIZED USER
		// 	}
		// } else {
		// 	getSystemUserDetails().then((res) => {
		// 		try {
		// 			let permissionUserId;
		// 			if (res.data.email == profileUser.email) {
		// 				permissionUserId = res.data.user_id;
		// 			}
		// 			// Dialog should be visible only when the access type is an administrator or company.
		// 			getUserPermissions(permissionUserId).then((res) => {
		// 				if (
		// 					res.data.data[0] &&
		// 					(res.data.data[0].access == 'Administrator' ||
		// 						res.data.data[0].access == 'Company')
		// 				) {
		// 					setAuthorizedUser(true); //SET USER TYPE AS AUTHORIZED USER
		// 				}
		// 			});
		// 		} catch (err) {
		// 			console.log(err);
		// 		}
		// 	});
		// }
	};

	const handleOptions = (type) => {
		if (sessionStorage.getItem('PreviewText')) {
			if (messagePopup?.handleClick) {
				messagePopup.handleClick();
			}
		} else {
			props.handleSelect(type);
		}
	};
	const handleSelect = (type) => {
		if (newAnnotation || updatedAnnotation || deletedAnnotation) {
			if (confirmPopup?.handleClick) {
				confirmPopup.handleClick();
			}
		} else {
			handleOptions(type);
		}
	};

	const redirectToPage = () => {
		if (props.handleSelect) {
			sessionStorage.removeItem('patientpreviewdata');
			let goBackUrl = sessionStorage.getItem('EndPreviewUrl');
			if (goBackUrl) {
				props.history.push(constants.ROUTE_URL + goBackUrl);
			}
		}
	};
	const cancelUpdate = () => {
		removeItemFromLocal(`newRapidAnnotation_${props?.match?.params?.docId}`);
		removeItemFromLocal(`updatedAnnotation_${props?.match?.params?.docId}`);
		removeItemFromLocal(`deletedAnnotation_${props?.match?.params?.docId}`);
		removeItemFromLocal(`selectedConcept_${props?.match?.params?.docId}`);
		removeItemFromLocal(`editmodeNormal_${props?.match?.params?.docId}`);
		removeItemFromLocal(`fromEditMultipleManual_${props?.match?.params?.docId}`);
		props.reloadPageData(true);
		if (props.handleSelect) {
			props.handleSelect(modalType);
		}
	};

	return (
		<div className="submenu settingmenulist">
			<ButtonToolbar>
				<DropdownButton
					title={<img className="icon-setting" src={UserSetting} />}
					alignRight
					id="dropdown-no-caret"
					onSelect={(modalType) => {
						setModalType(modalType);
						handleSelect(modalType);
					}}
				>
					{authorizedUser && (
						<Dropdown.Item eventKey={modalConstants.productSetting}>
							Product settings
						</Dropdown.Item>
					)}

					<Dropdown.Item eventKey={modalConstants.accountSetting}>
						Account settings
					</Dropdown.Item>

					{authorizedUser && (
						<Dropdown.Item eventKey={modalConstants.dataSetting}>
							Data administration
						</Dropdown.Item>
					)}
					{authorizedUser && !isAnalyticsProject && (
						<Dropdown.Item eventKey={modalConstants.studySetting}>
							Study administration
						</Dropdown.Item>
					)}
					<Dropdown.Divider />
					{props.redSidenav?.userRoles?.length > 1 && (
						<Dropdown.Item eventKey={modalConstants.userRoles}>
							Switch role
						</Dropdown.Item>
					)}
					<Dropdown.Item eventKey={modalConstants.logout}>Logout</Dropdown.Item>
				</DropdownButton>
			</ButtonToolbar>
			<MessagePopup
				rootClosexit={() => {}}
				open={(c) => (messagePopup = c)}
				text={
					'If you exit preview, your changes will be lost. Are you sure you want to exit preview?'
				}
				confirmClick={redirectToPage}
			/>
			<CancelRapidManual
				cancelRapidUpdate={cancelUpdate}
				open={(c) => {
					if (c?.handleClick) {
						setConfirmPopup({ handleClick: c?.handleClick });
					}
				}}
				revertRapidChanges={() => {}}
			/>
		</div>
	);
}

// SettingMenuList.propTypes = propTypes;

const mapStateToProps = (state) => state;

export default withRouter(connect(mapStateToProps)(SettingMenuList));
